import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { AuthService } from "../auth/auth.service";
import { GetPredefinedEmployeeSettingsAction } from "./settings.actions";

@Component({
  selector: "app-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.scss"],
  standalone: false,
})
export class SettingsComponent implements OnInit {
  constructor(
    public auth: AuthService,
    private store: Store,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(new GetPredefinedEmployeeSettingsAction());
  }
}
